export class ApiError extends Error {
  constructor(message: string, public status: number) { super(message); }
}

let redirectingToLogin = false;

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers || {});
  if (options.body !== undefined && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const response = await fetch(path, {
    credentials: "same-origin",
    ...options,
    headers
  });
  const text = await response.text();
  let payload: unknown = null;
  try { payload = text ? JSON.parse(text) : null; } catch { payload = text; }
  if (!response.ok) {
    const message = payload && typeof payload === "object" && "error" in payload ? String((payload as {error:unknown}).error) : `请求失败 (${response.status})`;
    if (
      response.status === 401 &&
      response.headers.get("X-Prive-Auth") === "required" &&
      typeof window !== "undefined" &&
      !redirectingToLogin
    ) {
      redirectingToLogin = true;
      // A role change, password reset or account disable can invalidate the
      // HttpOnly session while React still shows cached account state. A hard
      // navigation clears that state and lets /api/auth/status render login.
      window.location.replace("/");
    }
    throw new ApiError(message, response.status);
  }
  return payload as T;
}

export function formatDate(date?: string | null) {
  if (!date) return "待定";
  const value=date.slice(0,10);
  if(!/^\d{4}-\d{2}-\d{2}$/.test(value))return "待定";
  const parsed=new Date(`${value}T12:00:00`);
  if(Number.isNaN(parsed.getTime()))return "待定";
  return new Intl.DateTimeFormat("zh-CN", { month: "short", day: "numeric", weekday: "short" }).format(parsed);
}

export function today() {
  const value = new Date();
  return `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2,"0")}-${String(value.getDate()).padStart(2,"0")}`;
}
